import { Identity, Zip } from "@pdfking/tfunc"

import { getter } from "./getter"
import { sort } from "./sort"
import { to_array } from "./to_array"

/**
 * Sorts iterable by key functions.
 *
 * Sorts by multiple criteria in order. Uses getter for key extraction.
 *
 * @param iterable - Array, object, or primitive to sort
 * @param functions - Key function(s) or property name(s) (default: Identity)
 * @returns Sorted array
 *
 * @example
 * ```ts
 * import { sort_by } from "@pdfking/rfunc"
 *
 * sort_by([{ a: 2 }, { a: 1 }], "a") // [{ a: 1 }, { a: 2 }]
 * sort_by([{ a: 1, b: 2 }, { a: 1, b: 1 }], ["a", "b"])
 * ```
 */
export function sort_by(iterable, functions: any = Identity) {
  const getters = getter(to_array(functions))

  function compare(a, b) {
    for (let [v1, v2] of Zip(getters(a), getters(b))) {
      if (v1 !== v2) {
        return v1 > v2
      }
    }
    return false
  }

  return sort(iterable, compare)
}
